/**
 * @fileoverview Two-factor verification page.
 * @description Composes the auth page shell with the two-factor card. Route-level only — the
 * actual code entry, countdown, and verify/resend logic live in
 * TwoFactorForm/useVerifyTwoFactor/useResendTwoFactorCode.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { TwoFactorCard } from '@/features/auth'
import AuthLayout from '@/shared/components/layouts/AuthLayout'

/**
 * @component
 */
function TwoFactorPage() {
  return (
    <AuthLayout>
      <TwoFactorCard />
    </AuthLayout>
  )
}

export default TwoFactorPage
